import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaBriefcase, FaHome, FaPhoneAlt, FaInfoCircle } from 'react-icons/fa';
import navLogo from '../assets/Logos/ESMOB logos-03.png';
import { useTab } from '../context/TabContext';

const navLinks = [
  { id: 'HOME', label: 'Home', path: '/', icon: <FaHome /> },
  { id: 'ABOUT US', label: 'About Us', path: '/about/', icon: <FaInfoCircle /> },
  { id: 'SERVICES', label: 'Services', path: '/services/', icon: <FaBriefcase /> },
  { id: 'CAREERS', label: 'Careers', path: '/careers/', icon: <FaBriefcase /> },
  { id: 'CONTACT', label: 'Contact', path: '/contact/', icon: <FaPhoneAlt /> },
];

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const { activeTab, setActiveTab } = useTab();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = showMenu ? 'hidden' : 'auto';
  }, [showMenu]);

  useEffect(() => {
    const current = navLinks.find(link => link.path === location.pathname);
    if (current) {
      setActiveTab(current.id);
    }
  }, [location.pathname, setActiveTab]);

  return (
    <div
      className={`flex items-center justify-between py-4 px-6 text-sm fixed top-0 left-0 w-full z-50 transition-all duration-300  ${
        isScrolled || showMenu ? 'bg-[#2584C6] text-white' : 'bg-transparent text-white'
      }`}
    >
      <Link to="/" className="flex items-center cursor-pointer">
        <img
          src={navLogo}
          alt="Logo"
          className="object-contain h-10 w-auto md:h-12 xl:h-16 bg-transparent"
        />
      </Link>

      <ul className="hidden md:flex gap-6 font-medium items-center">
        {navLinks.map(({ label, id, path, icon }) => (
          <Link
            to={path}
            key={id}
            onClick={() => setActiveTab(id)}
            className={`flex items-center gap-1 transition-all duration-200 ${
              activeTab === id
                ? 'text-white opacity-100 font-semibold'
                : 'text-white opacity-60 hover:opacity-100'
            }`}
          >
            <span>{icon}</span> <span>{label}</span>
          </Link>
        ))}
      </ul>

      <div className="md:hidden">
        <FaBars
          size={24}
          className="cursor-pointer text-white"
          onClick={() => setShowMenu(true)}
        />
      </div>

      <div
        className={`fixed top-0 right-0 h-screen z-50 transition-all duration-300 ${
          showMenu ? 'w-64 p-6 shadow-lg' : 'w-0 overflow-hidden'
        } ${showMenu ? 'bg-[#2584C6] text-white' : 'bg-white text-gray-800'}`}
      >
        <div className="flex items-center justify-between mb-6">
          <Link to="/" onClick={() => setShowMenu(false)} className="flex items-center">
            <img
              src={navLogo}
              alt="Logo"
              className="h-10 w-auto object-contain max-w-[160px]"
            />
          </Link>
          <FaTimes
            size={22}
            className="cursor-pointer text-white"
            onClick={() => setShowMenu(false)}
          />
        </div>

        <ul className="flex flex-col gap-4 text-lg font-medium">
          {navLinks.map(({ label, id, path, icon }) => (
            <Link
              key={id}
              to={path}
              onClick={() => {
                setActiveTab(id);
                setShowMenu(false);
              }}
              className={`flex items-center gap-2 transition-all duration-200 ${
                activeTab === id
                  ? 'text-white opacity-100 font-semibold'
                  : 'text-white opacity-60 hover:opacity-100'
              }`}
            >
              {icon} {label}
            </Link>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
